import { render, staticRenderFns } from "./ExcludeAttachments.vue?vue&type=template&id=6734c951&lang=pug"
import script from "./ExcludeAttachments.vue?vue&type=script&lang=js"
export * from "./ExcludeAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports